import { useEffect, useState } from "react";
import { Bell, BellOff } from "lucide-react";
import { toast } from "sonner";
import { pushSupported, subscribeClientPush } from "@/lib/push";

function currentPerm() {
  if (typeof window === "undefined" || !("Notification" in window)) return "unsupported";
  return Notification.permission;
}

export default function EnableNotificationsButton({ className = "" }) {
  const [perm, setPerm] = useState(currentPerm());

  useEffect(() => {
    setPerm(currentPerm());
  }, []);

  if (perm === "unsupported") return null;

  const ask = async () => {
    try {
      const res = await Notification.requestPermission();
      setPerm(res);
      if (res === "granted") {
        try {
          if (pushSupported()) await subscribeClientPush();
        } catch (_e) { /* ignore */ }
        toast.success("Notifications activées ✓ Vous recevrez les changements de statut en temps réel.");
        try {
          new Notification("Swiftlink-Africa", {
            body: "Les notifications sont activées sur cet appareil.",
            icon: "/brand/swiftlink-logo.png",
          });
        } catch (_e) { /* ignore */ }
      } else if (res === "denied") {
        toast.error("Notifications refusées. Activez-les dans les paramètres du navigateur.");
      }
    } catch (_e) { /* ignore */ }
  };

  const isGranted = perm === "granted";
  const isDenied = perm === "denied";

  return (
    <button
      type="button"
      onClick={isDenied ? undefined : ask}
      disabled={isDenied || isGranted}
      data-testid="enable-notifications-btn"
      className={`inline-flex items-center gap-2 rounded-full border-2 px-4 py-2 text-sm font-medium transition disabled:cursor-default ${className}`}
      style={{
        borderColor: isGranted ? "transparent" : "var(--sl-primary)",
        background: isGranted ? "rgb(16 185 129 / 0.12)" : "transparent",
        color: isGranted ? "rgb(5, 95, 70)" : isDenied ? "rgb(180, 60, 60)" : "var(--sl-primary)",
      }}
    >
      {isGranted ? <Bell size={14} /> : <BellOff size={14} />}
      {isGranted
        ? "Notifications actives"
        : isDenied
          ? "Notifications bloquées (paramètres du navigateur)"
          : "Activer les notifications"}
    </button>
  );
}
